import { UserNameItem } from 'modules/user';
import { usePaymentReport } from './context/ReportObjectPaymentsProvider';
import type { PaymentReportGroup } from './model/reportObjectPayments';
import ReportObjectPaymentsTotals from './ReportObjectPaymentsTotals';
import ReportObjectPaymentsTable from './ReportObjectPaymentsTable';

const ReportObjectPaymentsGroup = ({ group }: { group: PaymentReportGroup }) => {
    const { filters } = usePaymentReport();
    const row = group.rows[0];
    const userPicture = filters.groupBy === 'owner' ? row?.ownerPicture : row?.authorPicture;
    const userEmail = filters.groupBy === 'owner' ? row?.ownerEmail : row?.authorEmail;

    return (
        <div className="mb-4">
            <div className="object-payments-group-header mb-2">
                <div className="object-payments-group-user">
                    {filters.groupBy === 'object' ? (
                        <h6 className="mb-0 text-break">{group.name}</h6>
                    ) : (
                        <UserNameItem user={{ ID: group.id, userName: group.name, userPicture: userPicture || undefined, userEmail: userEmail || undefined }} />
                    )}
                </div>
                <div className="object-payments-group-totals"><ReportObjectPaymentsTotals rows={group.rows} /></div>
            </div>
            <ReportObjectPaymentsTable rows={group.rows} />
        </div>
    );
};

export default ReportObjectPaymentsGroup;
